import { createContext } from "react";
import { INewsletterContext } from "./modalConfig.types";

export const NewsletterContext = createContext<INewsletterContext | undefined>(
  undefined
);
